module.exports = __webpack_public_path__ + "img/logo2.e001a3f1.png";